$(document).ready(function(){
  // hero slider
  var $s = $('.hero-carousel');
  var $sNews = $('.news-slider');

  // play video in slick on init
  $s.on('init', function (event, slick, currentSlide) {
    var vid = $('.slick-active').find('video');
    if (vid.length > 0) {
      $(vid)[0].play();
    }
  });

  // set us up the bomb
  $s.slick({
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    arrows: false,
    autoplay: false,
    fade: true,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    appendDots: $('.slick-dots-space')
  });

  // apply active class and dots
  $s.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    var activeSlide = nextSlide + 1;
    var slide_child = ':nth-child('+ activeSlide +')';
    var vid = $(slick.$slides[currentSlide]).find('video');
    
    // set the on-state of the dot
    $('.slick-dots li').eq('.slick-active').removeClass('slide-is-active');
    $('.slick-dots li'+ slide_child +'').eq(nextSlide).addClass('slide-is-active');

    if (vid.length > 0) {
      $(vid)[0].pause();
    }
  });

  // find and play video on the slide
  $s.on('afterChange', function (event, slick, currentSlide) {
    var vid = $(slick.$slides[currentSlide]).find('video');
    if (vid.length > 0) {
      // $(vid)[0].currentTime = 0;
      $s.slick('slickPause');
      $(vid)[0].play();
    }

    // play video 3 seconds after finishes playing
    vid.on('ended', function () {
      $s.slick('slickPlay');
    });
  });

  //news slider
  $sNews.slick({
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.news-prev').click(function(){
    $($sNews).slick('slickPrev');
  });
  $('.news-next').click(function(){
    $($sNews).slick('slickNext');
  });

});